import { Heading as HeadingRaw, HeadingProps } from "@chakra-ui/react";

export const Heading = (props: HeadingProps) => {
  return <HeadingRaw fontSize={["1xl", "2xl"]} {...props} />;
};
